import { useCallback } from "react";
import confetti from "canvas-confetti";

export const useConfetti = () => {
  const colors = [
    "#FFD700",
    "#FF6B6B",
    "#4ECDC4",
    "#45B7D1",
    "#96CEB4",
    "#FFEAA7",
    "#DDA0DD",
    "#98D8C8",
  ];
  const fireConfetti = useCallback(() => {
    // Left side explosion
    confetti({
      particleCount: 200,
      angle: 120,
      spread: 55,
      startVelocity: 60,
      origin: { x: 1, y: 0.5 },
      colors: colors,
    });

    // Right side explosion
    confetti({
      particleCount: 200,
      angle: 60,
      spread: 55,
      startVelocity: 60,
      origin: { x: 0, y: 0.5 },
      colors: colors,
    });

    // Center burst for extra celebration
    setTimeout(() => {
      confetti({
        particleCount: 200,
        angle: 60,
        spread: 55,
        startVelocity: 60,
        origin: { x: 0, y: 0.5 },
        colors: colors,
      });
      confetti({
        particleCount: 200,
        angle: 120,
        spread: 55,
        startVelocity: 60,
        origin: { x: 1, y: 0.5 },
        colors: colors,
      });
    }, 300);
  }, []);

  const fireConfettiBurst = useCallback(() => {
    // Run confetti 3 times with delays
    const runConfetti = () => {
      // Left side explosion
      confetti({
        particleCount: 200,
        angle: 120,
        spread: 55,
        startVelocity: 60,
        origin: { x: 1, y: 0.5 },
        colors: colors,
        duration: 2000,
      });

      // Right side explosion
      confetti({
        particleCount: 200,
        angle: 60,
        spread: 55,
        startVelocity: 60,
        origin: { x: 0, y: 0.5 },
        colors: colors,
        duration: 2000,
      });
    };

    // First burst immediately
    runConfetti();

    // Second burst after 500ms
    setTimeout(() => {
      runConfetti();
    }, 300);

    // Third burst after 1000ms
    setTimeout(() => {
      runConfetti();
    }, 700);
  }, []);

  return { fireConfetti, fireConfettiBurst };
};
